import * as React from 'react';
import { Button } from 'antd';
import { ExportOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

import { PATHS } from 'router/config';

interface IJournalLinkButtonProps {
  groupId: string;
  size?: 'small' | 'middle' | 'large';
}

/**
 * Opens the group's journal (`/journal/{groupId}`, where journalId == groupId)
 * in a new tab — for cross-checking lesson dates that sometimes differ between
 * the journal and Zoom. Rendered only where a group id is actually known.
 */
export const JournalLinkButton = ({
  groupId,
  size = 'small',
}: IJournalLinkButtonProps) => {
  const { t } = useTranslation();
  return (
    <Button
      size={size}
      icon={<ExportOutlined />}
      onClick={() =>
        window.open(`${PATHS.journal}/${groupId}`, '_blank', 'noopener')
      }
    >
      {t('pages.zoom.openJournal')}
    </Button>
  );
};
